import React, { useRef, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
// import { useNavigate, useLocation } from 'react-router-dom';

const AuthStateTransfer = () => {
  const { init } = useAuth();
  const initialized = useRef(false);
  // const location = useLocation();

  // console.log(location)

  useEffect(() => {
    if (!initialized.current) {
      init();
      initialized.current = true;
    }
  }, [init]);

  return null;
};

export default AuthStateTransfer;
